export default {
  accessToken: 'pk.eyJ1Ijoic29sb2RrdWkiLCJhIjoiY2wwZ2p6Y2JsMTNsaDNiazZjY3E4ZXNlZyJ9.4XaF8wyaoT6R-rapSO5-8Q',
  style: 'mapbox://styles/mapbox/streets-v11',
  initialZoom: 16,
  center: {
    lng: 8.386934137786076,
    lat: 47.39070436575281
  }
}
